import React, { Component } from 'react';
import Swiper from 'react-id-swiper';

import LazyImage from 'components/LazyImage';

import img1 from 'shared/img/about-one.webp';
import img1Sm from 'shared/img/about-one-sm.webp';
import colorLogo from 'shared/img/color-logo.webp';
import spartaLogo from 'shared/img/sparta-logo-w.webp';

import dip0 from 'shared/img/dip0.jpg';
import dip1 from 'shared/img/dip1.jpg';
import dip2 from 'shared/img/dip2.jpg';
import dip3 from 'shared/img/dip3.jpg';
import dip4 from 'shared/img/dip4.jpg';

class About extends Component {
  render() {
    const { style } = this.props;

    const params = {
      lazy: true,
      loop: true,
      containerClass: style.swiper,
      navigation: {
        nextEl: '.swiper-next',
        prevEl: '.swiper-prev',
      }
    }

    const banners = [
      {id: 0, src: dip0},
      {id: 1, src: dip1},
      {id: 2, src: dip2},
      {id: 3, src: dip3},
      {id: 4, src: dip4},
    ];

    return(
      <div className={style.root}>
        <div className={style.row}>
          <div className={style.wrapperOne}>
            <p className={style.textOne}>Секрет оновлення життя та розвитку людства полягає в <span>інноваціях</span></p>
            <h1 className={style.headingOne}>Майбутнє створюють ті, хто здатен його уявити та <span>втілити в життя</span></h1>
            <p className={style.textOne}>Наші дії сьогодні залишають <i>спадок</i>, який переживе нас</p>
          </div>
          <LazyImage
            image={{
              className: style.bgImage,
              src: img1,
              alt: "",
              lowResSrc: img1Sm
            }}
          />
        </div>
        <div className={style.row}>
          <div className={style.rowTow}>
            <div className={style.rowLogo}>
              <img className={style.colorLogo} src={colorLogo} alt="" />
              <div className={style.divider}></div>
              <img className={style.spartaLogo} src={spartaLogo} alt="" />
            </div>
            <h2 className={style.headingTwo}>Якість без компромісів</h2>
            <div className={style.content}>
              <div className={style.contentCol}>
                <p className={style.contentText}>Дотримуючись цього принципу, ми цінуємо час клієнтів, забезпечуємо <strong>високі стандарти</strong> якості та швидкості, пропонуємо найкращі ціни та прислухаємося до їхніх побажань.</p>
              </div>
              <div className={style.contentCol}>
                <p className={style.contentTextT}>Ми створюємо не лише послуги, а й позитивний досвід,  роблячи філософію творчості основою <i>успішного бізнесу</i>.</p>
              </div>
            </div>
          </div>
        </div>
        <div className={style.row}>
          <Swiper {...params}>
            {banners.map(
              banner => 
                <div className={style.banner} key={banner.id}>
                  <img src={banner.src} className={style.swImage} alt="" />
                </div>
            )}
          </Swiper>
          <div className={style.navText}>Показати наступний диплом</div>
        </div>
      </div>
    )
  }
}

About.defaultProps = {
  style: require('./About.module.scss')
}

export default About;